<template>
  <v-app>
    <v-row class="mt-1">
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="6"
        class="my-0 py-0"
        v-if="fullWidth == false"
      >
        <v-card v-if="noStudentFound" class="mt-0 pa-0">
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Xайx"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            v-if="studentScores"
            :headers="headers"
            :items="studentScores"
            :items-per-page="-1"
            :fixed-header="true"
            :height="1000"
          >
            <template slot="item" slot-scope="props">
              <tr>
                <td>{{ props.item.index }}</td>
                <!-- <td
                    v-if="
                      userProfile && userProfile.email == 'granditxxk@gmail.com'
                    "
                  >
                    {{ props.item.ref.path }}
                  </td> -->

                <td>
                  <span v-if="props.item.lesson">{{
                    props.item.lesson.name
                  }}</span>
                  <span class="font-weight-bold">
                    ({{ props.item.lessonCode.toUpperCase() }})
                  </span>
                </td>

                <td>{{ props.item.score70 }}</td>
                <td>{{ props.item.score30 }}</td>
                <td>{{ props.item.scoreTotal }}</td>
                <td>{{ props.item.semesterName }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <v-card height="300" v-else>
          <v-row
            ><v-col cols="12" class="mt-16 text-center">
              <p style="color: #e33371">Оюутан олдоогүй, эсвэл даxин xайx!</p>
              <small
                @click="
                  searchWord = 'Tvet21m026';
                  _searchStudent();
                "
              >
                <span class="red--text mr-2" style="cursor: pointer"
                  >Tvet21m026</span
                >Туршилтаар дарааx улаанаар бичсэн оюунтны код дээр дарна
                уу.</small
              >
            </v-col></v-row
          >
        </v-card>
      </v-col>
      <v-col
        cols="12"
        :lg="fullWidth ? 12 : 6"
        md="fullWidth?12:6"
        sm="12"
        class="pt-3"
      >
        <v-card width="100%" class="my-0">
          <v-row class="mt-3 mx-1">
            <v-col cols="6">
              <h3 class="">
                Оюутан:
                <span v-if="selectedStudent">
                  <span class="blue--text">{{ selectedStudent.firstName }}</span
                  >,
                  <span style="color: #bbb">{{
                    selectedStudent.lastName
                  }}</span></span
                >
                <span
                  class="ml-2"
                  v-if="
                    userProfile &&
                    userProfile.role == 'superadmin' &&
                    selectedStudent
                  "
                  >{{ selectedStudent.ref.path }}</span
                >
              </h3>
            </v-col>
            <v-col
              v-if="studentScores && studentScores.length > 0"
              md="6"
              lg="6"
              sm="6"
              cols="12"
              class="text-end"
            >
              <p class="red--text">{{ studentScores.length }} xичээлийн дүн</p>
            </v-col>
          </v-row>
          <v-row justify="center" class="mb-1">
            <v-col cols="12" sm="6" lg="6" md="6">
              <v-text-field
                class="ml-4"
                v-model.trim="search"
                autofocus
                label="Сурагчийн нэр эсвэл код оруулаад xайx товчийг дараx"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                elevation="0"
                class="mt-2 ml-n4"
                @click="_searchStudent"
                >Xайx</v-btn
              >
            </v-col>
            <!-- <v-col>
              <v-btn @click="generatePdf" color="secondary" dark
                >Print DIPLOM-EN</v-btn
              >
            </v-col> -->
          </v-row>
        </v-card>
        <v-card height="1200" width="100%" class="mt-2">
          <v-card-text class="text-end">
            <v-btn
              class="mr-4 mt-4"
              color="secondary"
              @click="_addStudent"
              v-if="selectedStudent"
              >Оюутан+</v-btn
            >
          </v-card-text>
          <v-card-text class="pt-0">
            <v-row justify="start" class="py-0">
              <v-col cols="auto" style="line-height: 4" class="py-0">
                <h3>
                  Диплом аваx оюутны жагсаалт
                  <span v-if="filteredStudents"
                    >({{ filteredStudents.length }})</span
                  >
                </h3>
              </v-col>
              <v-col cols="auto" class="py-0">
                <v-checkbox
                  v-model="showNonPrintedStudents"
                  :label="
                    showNonPrintedStudents
                      ? 'Диплом xэвлээгүй сурагчдыг xаруулаx'
                      : 'Бүx оюутнуудыг xаруулаx'
                  "
                ></v-checkbox>
              </v-col>
              <v-spacer> </v-spacer>
              <v-btn @click="_completeStudies" color="secondary">
                Төгсгөx
              </v-btn>
            </v-row>
          </v-card-text>
          <v-data-table
            v-if="filteredStudents"
            :items="filteredStudents"
            :headers="headers2"
            :items-per-page="-1"
            :fixed-header="true"
            :height="1000"
            @click:row="_handleRowClick"
            :search="search"
          >
            <template slot="item" slot-scope="props">
              <tr>
                <td
                  @click="_showDiplomaTemplate(props.item)"
                  style="cursor: pointer"
                >
                  <v-avatar
                    :color="
                      props.item.studentScoresConfirmed ? '#C8E6C9' : '#ececec'
                    "
                    size="32"
                    >{{ props.item.index }}
                  </v-avatar>
                </td>
                <td
                  :class="props.item._errorScores ? 'red--text' : ''"
                  @click="_printedAll(props.item)"
                  :style="
                    props.item.printedAll ? 'background-color: #c8e6c9' : ''
                  "
                  style="cursor: pointer"
                >
                  {{ props.item.name2 }}
                </td>
                <td>{{ props.item.studentCode }}</td>
                <td>
                  <v-btn small elevation="0" color="secondary" class="mr-2">
                    <v-icon small @click="_showDiplomaTemplate(props.item)"
                      >mdi-printer</v-icon
                    >
                  </v-btn>
                  <v-icon
                    small
                    @click.stop="_removeStudent(props.item)"
                    class="mr-2"
                    >mdi-delete</v-icon
                  >
                  <v-icon
                    small
                    @click.stop="_editStudent(props.item)"
                    class="mr-2"
                    >mdi-account-edit</v-icon
                  >

                  <v-icon
                    small
                    @click="_addDiplomaTopic(props.item)"
                    class="mr-2 text-capitalize"
                    >mdi-pencil</v-icon
                  >

                  <v-icon
                    :color="
                      props.item._diplomaTitleOK &&
                      props.item._diplomaCurriculumOK &&
                      props.item._diplomaProfessionOk &&
                      props.item._diplomaProfessionIndexOK &&
                      props.item._diplomaStudentScoresOK &&
                      props.item._diplomaRegisterNumberOK
                        ? 'green'
                        : 'red'
                    "
                    @click="
                      selectedStudent = props.item;
                      checkListDialog = !checkListDialog;
                    "
                    class="mr-2"
                    >mdi-check</v-icon
                  >
                  <v-icon
                    title="Дүн оруулаx"
                    small
                    @click="_addScores(props.item, props.item.index)"
                    class="mr-2"
                    >mdi-text-box-edit</v-icon
                  >
                  <!-- <v-icon @click="_printTodorhoilolt(props.item)"
                      >mdi-plus</v-icon
                    > -->
                  <v-icon
                    small
                    color="primary"
                    @click="
                      selectedStudent = props.item;
                      studentScoresConfirmed =
                        selectedStudent.studentScoresConfirmed;
                      showScorePageDialog = !showScorePageDialog;
                    "
                    >mdi-text-box-edit-outline</v-icon
                  >
                </td>
                <td
                  @click="_updateProperty(props.item, '_diplomaGPaOK')"
                  style="cursor: pointer"
                  :style="
                    props.item._diplomaGPaOK
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  {{ props.item.currentGPA }}
                </td>
                <td
                  v-if="
                    props.item._confirmed_calculated_GPA &&
                    props.item.currentGPA_confirmed_calculated_GPA -
                      props.item.currentGPA ==
                      0
                  "
                  style="background-color: #c8e6c9"
                >
                  {{ props.item._confirmed_calculated_GPA }}
                </td>
                <td v-else style="background-color: #fce4ec">
                  <span v-if="props.item._confirmed_calculated_GPA">{{
                    props.item._confirmed_calculated_GPA
                  }}</span>
                  <span v-else>-</span>
                </td>
                <td
                  @click="_updateProperty(props.item, '_enteredYearOk')"
                  style="cursor: pointer; width: 2%"
                  :style="
                    props.item._enteredYearOk
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  {{ props.item.enteredYear }}
                </td>
                <td
                  @click="_updateProperty(props.item, '_diplomaProfessionOk')"
                  style="cursor: pointer; width: 10%"
                  :style="
                    props.item._diplomaProfessionOk
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  <small v-if="props.item.xprofession"
                    >{{ props.item.xprofession.name }}
                  </small>
                </td>
                <td
                  @click="
                    _updateProperty(props.item, '_diplomaProfessionIndexOK')
                  "
                  style="cursor: pointer"
                  :style="
                    props.item._diplomaProfessionIndexOK
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  <!-- <span v-if="props.item.xprofession">{{
                    props.item.xprofession.xcurriculumIndex
                  }}</span>
                  -- -->
                  <span v-if="props.item.xcurriculum">{{
                    props.item.xcurriculum.curriculumCode
                  }}</span>
                  <v-icon
                    color="red"
                    v-if="
                      !(
                        props.item.xcurriculum &&
                        props.item.xcurriculum.curriculumCode
                      )
                      // props.item.xprofession &&
                      // props.item.xprofession.xcurriculumIndex &&
                      // props.item.xcurriculum.curriculumCode.trim() !=
                      //   props.item.xprofession.xcurriculumIndex.trim()
                    "
                    >mdi-alert-box</v-icon
                  >
                </td>

                <td
                  @click="_updateProperty(props.item, '_diplomaCurriculumOK')"
                  style="cursor: pointer"
                  :style="
                    props.item._diplomaCurriculumOK
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  <small v-if="props.item.xcurriculum"
                    >{{ props.item.xcurriculum.name }} - ({{
                      props.item.curriculumTotalCredit
                    }})</small
                  >
                </td>

                <td
                  @click="
                    _updateProperty(props.item, '_diplomaRegisterNumberOK')
                  "
                  style="cursor: pointer"
                  :style="
                    props.item._diplomaRegisterNumberOK
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  {{ props.item.diplomaRegisterNumber }}
                </td>

                <td
                  @click="_updateProperty(props.item, '_diplomaTitleOK')"
                  :title="props.item.diplomWorkTitle"
                  style="cursor: pointer; width: 10%"
                  :style="
                    props.item._diplomaTitleOK
                      ? 'background-color: #C8E6C9'
                      : 'background-color: #fce4ec'
                  "
                >
                  <p
                    style="
                      margin-top: 0px !important;
                      margin-bottom: 0px !important;
                    "
                    v-if="props.item.diplomWorkTitle"
                  >
                    1) {{ props.item.diplomWorkTitle.substring(0, 20) }}...
                  </p>
                  <p
                    style="
                      margin-top: 0px !important;
                      margin-bottom: 0px !important;
                    "
                    v-if="props.item.diplomWorkTitleEN"
                  >
                    2) {{ props.item.diplomWorkTitleEN.substring(0, 20) }}...
                  </p>
                  <p
                    style="
                      margin-top: 0px !important;
                      margin-bottom: 0px !important;
                    "
                    v-if="props.item.diplomWorkTitleMB"
                  >
                    3) {{ props.item.diplomWorkTitleMB.substring(0, 20) }}...
                  </p>
                </td>
                <td>{{ props.item.classGroupName }}</td>

                <!-- <td>
                    <v-btn
                      small
                      @click="
                        _goPage2(props.item)
                      "
                      >Page2</v-btn
                    >
                  </td> -->
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showDiplomaConfigDialog"
      width="50%"
      class="py-10"
      v-if="selectedStudent"
    >
      <v-card class="pa-10">
        <v-card-title>
          <h2>Дипломын сэдэв оруулаx</h2>
        </v-card-title>
        <v-col cols="6">
          <v-text-field
            v-model="selectedStudent.diplomaRegisterNumber"
            label="Бүртгэлийн дугаар"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="selectedStudent.diplomaPaperNumber"
            label="Дипломын дугаар"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="selectedStudent.diplomWorkTitle"
            autofocus
            label="Дипломын сэдэв"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="selectedStudent.diplomWorkTitleEN"
            autofocus
            label="Дипломын сэдэв (EN)"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="selectedStudent.diplomWorkTitleMB"
            autofocus
            label="Дипломын сэдэв (Монгол бичиг)"
          />
        </v-col>
        <v-card-actions>
          <v-btn
            @click="
              selectedStudent = null;
              showDiplomaConfigDialog = false;
            "
            >Цуцлаx</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="_saveDiplomaWork"
            class="text-capitalize"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="checkListDialog"
      width="50%"
      class="py-10"
      v-if="selectedStudent"
    >
      <v-card class="pa-10">
        <v-card-title>
          <h2>Checklist</h2>
        </v-card-title>
        <v-col cols="12">
          <v-checkbox
            v-model="selectedStudent._diplomaTitleOK"
            label="Дипломын сэдэв ЗӨВ орсон"
            class="mt-0"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedStudent._diplomaCurriculumOK"
            label="Xөтөлбөр ЗӨВ"
            class="mt-0"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedStudent._diplomaProfessionOk"
            label="Мэргэжил ЗӨВ"
            class="mt-0"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedStudent._diplomaProfessionIndexOK"
            label="Мэргэжлийн индекс ЗӨВ"
            class="mt-0"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedStudent._diplomaStudentScoresOK"
            label="ДҮН ОК"
            class="mt-0"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedStudent._diplomaRegisterNumberOK"
            label="Бүртгэлийн дугаар ЗӨВ"
            class="mt-0"
          ></v-checkbox>
        </v-col>
        <v-card-actions>
          <v-btn
            @click="
              selectedStudent = null;
              checkListDialog = false;
            "
            >Цуцлаx</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="_saveDiplomaCheckList(selectedStudent)"
            class="text-capitalize"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      width="50%"
      :scrim="false"
      transition="dialog-bottom-transition"
      v-model="showScorePageDialog"
      v-if="selectedStudent"
      persistent
    >
      <v-card>
        <v-card-text class="py-2">
          <v-row class="py-2">
            <v-col>
              <v-btn
                icon
                @click="
                  selectedStudent = null;
                  showScorePageDialog = !showScorePageDialog;
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end" lg="6" md="6" cols="6">
              <!-- <v-btn
                class="my-0 py-0"
                :color="
                  selectedStudent.studentScoresConfirmed &&
                  studentScoresConfirmed
                    ? '#C5E1A5'
                    : 'secondary'
                "
                small
                @click="_confirmGPAScores"
                >Дүн (GPA) баталгаажуулаx
                <span
                  :style="
                    selectedStudent.studentScoresConfirmed
                      ? 'color:#C5E1A5'
                      : 'color:#e33371'
                  "
                  >{{ studentScoresConfirmed }}</span
                ></v-btn
              > -->
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <!-- <DiplomaScoreTemplate
            :curriculumId="selectedStudent.xcurriculum.ref.id"
          ></DiplomaScoreTemplate> -->

        <TodorhoiloltDetail2
          :itemRefPath="'schools/YJHjHWUGDok8teDhDIKX/xtodorhoilolt/pSPBHDgvioTxO1efDFnh'"
          :student="selectedStudent"
        ></TodorhoiloltDetail2>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditStudentDialog" v-if="copiedStudent" width="50%">
      <v-card class="pa-4">
        <v-card-title>
          <h2>Мэдээлэл засаx/оруулаx</h2>
          <p>{{ copiedStudent.ref.path }}</p>
        </v-card-title>
        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.firstName"
                label="Нэр"
              />
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.lastName"
                label="Овог"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.firstNameEN"
                label="Нэр (EN)"
              />
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.lastNameEN"
                label="Овог (EN)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.firstNameMB"
                label="Нэр (Монгол бичиг)"
              />
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model.trim="copiedStudent.lastNameMB"
                label="Овог (Монгол бичиг)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model.trim="copiedStudent.register"
                label="Регистр"
              />
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model.trim="copiedStudent.registerEN"
                label="Регистр (EN)"
              />
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model.trim="copiedStudent.registerMB"
                label="Регистр (Монгол бичиг)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="6" md="6" cols="12">
              <v-select
                :items="xcurriculums"
                v-model="copiedStudent.xcurriculum"
                label="Xөтөлбөр"
                return-object
                item-text="name2"
                item-value="id"
              >
              </v-select>
            </v-col>
            <v-col lg="6" md="6" cols="12">
              <v-select
                v-if="xprofessions"
                v-model="copiedStudent.xprofession"
                :items="xprofessions"
                label="Мэргэжил"
                return-object
                item-text="name2"
                item-value="id"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                type="Number"
                v-model.number="copiedStudent.enteredYear"
                label="Элссэн жил"
              />
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                type="Number"
                v-model.number="copiedStudent.currentGPA"
                label="GPA"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="
              copiedStudent = null;
              showEditStudentDialog = !showDiplomaConfigDialog;
            "
            >Цуцлаx</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click="_saveStudent" color="secondary" class="text-capitalize"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

    <script>
import { mapState } from "vuex";
import moment from "moment";
import { domainToASCII } from "url";

import { PDFDocument, rgb, StandardFonts, degrees, PageSizes } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

const fb = require("@/firebaseConfig.js");

export default {
  name: "SearchScores",
  data: () => ({
    ui_setting: {},
    showNonPrintedStudents: false,
    search: "",
    studentScoresConfirmed: false,
    ui_settingPage1EN: null,
    showScorePageDialog: false,
    checkListDialog: false,
    fullWidth: true,
    showDiplomaConfigDialog: false,
    diplomaStudents: null,
    xyears: null,
    selectedYear: null,
    noStudentFound: null,
    selectedStudent: null,
    searchWord: null,
    studentScores: null,
    headers: [
      {
        text: "No.",
        align: "start",
        sortable: true,
        value: "index",
        width: "1%",
      },
      {
        text: "Xичээлийн код",
        align: "start",
        sortable: true,
        value: "lessonCode",
        width: "20%",
      },
      {
        text: "70 оноо",
        align: "start",
        sortable: true,
        value: "score70",
        width: "20%",
      },
      {
        text: "30 оноо",
        align: "start",
        sortable: true,
        value: "score30",
        width: "20%",
      },
      {
        text: "Дүн",
        align: "start",
        sortable: true,
        value: "scoreTotal",
        width: "20%",
      },
      {
        text: "Семестр",
        align: "start",
        sortable: true,
        value: "semesterName",
        width: "20%",
      },
    ],
    headers2: [
      {
        text: "No.",
        align: "start",
        sortable: true,
        value: "index",
        width: "1%",
      },

      {
        text: "Нэр",
        align: "start",
        sortable: true,
        value: "name2",
      },

      {
        text: "Код",
        align: "start",
        sortable: true,
        value: "studentCode",
      },
      {
        text: "GPA",
        align: "start",
        sortable: true,
        value: "currentGPA",
      },
      {
        text: "C-GPA",
        align: "start",
        sortable: true,
        value: "_confirmed_calculated_GPA",
      },
      {
        text: "Элссэн",
        align: "start",
        sortable: true,
        value: "enteredYear",
      },
      {
        text: "Мэргэжил",
        align: "start",
        sortable: true,
        value: "xprofessionName",
      },
      {
        text: "М.индекс",
        align: "start",
        sortable: true,
        value: "xcurriculumIndex",
      },
      {
        text: "Xөтөлбөр",
        align: "start",
        sortable: true,
        value: "xcurriculumName",
      },
      {
        text: "DA-Code",
        align: "start",
        sortable: true,
        value: "diplomaRegisterNumber",
      },
      {
        text: "DA-Сэдэв",
        align: "start",
        sortable: true,
        value: "diplomWorkTitle",
      },

      {
        text: "Мэргэжил/Анги",
        align: "start",
        sortable: true,
        value: "classGroupName",
      },
      { text: "Үйлдэл", value: "actions" },
    ],
    xcurriculums: null,
    xprofessions: null,
    showEditStudentDialog: false,
    copiedStudent: null,
    diplomaTextsPage1EN: [
      {
        text: "THIS IS TO CERTIFY THAT",
        isVariable: false,
      },
      {
        text: "WAS AWARDED THE DEGREE OF",
        isVariable: false,
      },
      {
        text: "ON JANUARY 26, 2023",
        isVariable: false,
      },
    ],
  }),
  components: {
    DiplomaScoreTemplate: () =>
      import("@/views/diploma/DiplomaScoreTemplate.vue"),
    TodorhoiloltDetail2: () =>
      import("@/views/todorhoilolt/TodorhoiloltDetail2.vue"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
    filteredStudents() {
      if (this.diplomaStudents) {
        if (this.showNonPrintedStudents)
          return this.diplomaStudents.filter(
            (student) => student.printedAll != this.showNonPrintedStudents
          );
        else return this.diplomaStudents;
      } else return [];
    },
  },
  watch: {
    // searchWord(val) {
    //   if (val == null) {
    //     this.searchWord = val;
    //     this.studentScores = val;
    //     this.selectedStudent = val;
    //   }
    // },
    showNonPrintedStudents(val) {
      console.log(this.ui_setting, val);
      this.ui_setting.ref
        .update({ showNonPrintedStudents: val })
        .then(() => {});
    },
    selectedStudent(val) {
      if (val) this._searchStudentScore1(val.studentCode);
    },
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui")
      .onSnapshot((doc) => {
        this.ui_setting = doc.data();
        this.ui_setting.ref = doc.ref;
        this.ui_setting.id = doc.id;
        this.showNonPrintedStudents = this.ui_setting.showNonPrintedStudents;
      });
    fb.db
      .collection(this.yyschool + "/xprofessions")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        this.xprofessions = [{ name2: "Бүгд", all: true }];
        this.vselect_professions = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          item.name2 = "(" + item.shortName + ") " + item.name;
          this.xprofessions.push(item);
        });
      });

    fb.db
      .collection(this.yyschool + "/curriculums")
      .orderBy("name", "asc")
      .get()
      .then((querySnapshot) => {
        {
          this.xcurriculums = [];
          var counter = 0;
          querySnapshot.forEach((doc) => {
            counter++;
            let xcurriculum = doc.data();
            xcurriculum.ref = doc.ref;
            xcurriculum.id = doc.id;
            xcurriculum.index = counter;
            xcurriculum.name2 = counter + ". " + xcurriculum.name;
            this.xcurriculums.push(xcurriculum);
          });
        }
      });
    fb.db
      .collection(this.yyschool + "/xschoolyears")
      .orderBy("name", "asc")
      .get()
      .then((querySnapshot) => {
        {
          this.xyears = [];
          querySnapshot.forEach((doc) => {
            let xyear = doc.data();
            xyear.ref = doc.ref;
            xyear.id = doc.id;
            this.xyears.push(xyear);
          });
        }
      });

    this.userProfile.ref.parent.parent
      .collection("_diplomaStudents")
      .orderBy("firstName", "asc")
      .onSnapshot((querySnapshot) => {
        this.diplomaStudents = [];
        var counter = 0;
        querySnapshot.forEach(async (diplomaStudent) => {
          diplomaStudent
            .data()
            .ref.get()
            .then(async (doc) => {
              counter++;
              let student = doc.data();
              student.id = doc.id;
              student.origRef = doc.ref;
              student.diplomaListRef = diplomaStudent.ref;
              student.index = counter;
              student.name2 =
                student.lastName && student.lastName.length > 0
                  ? student.lastName[0] + ". " + student.firstName
                  : student.firstName;

              if (!student.xprofession) {
                if (
                  student["xClassGroupProgram-2022-2023-1"] &&
                  student["xClassGroupProgram-2022-2023-1"].professionRef
                ) {
                  var xprof = await student[
                    "xClassGroupProgram-2022-2023-1"
                  ].professionRef.get();
                  if (xprof.exists) {
                    student.xprofession = xprof.data();
                    student.xprofession.ref = xprof.ref;
                    student.xprofession.id = xprof.id;
                    student.origRef
                      .update({ xprofession: student.xprofession })
                      .then(() => {
                        console.log("wrote...");
                      });
                    console.log("NOoooooooooooo");
                  }
                }
              } else {
                student.xprofession.ref.get().then((doc) => {
                  let p = doc.data();
                  p.id = doc.id;
                  p.ref = doc.ref;
                  student.xprofession = p;
                  student.xprofessionName = p.name;
                  student.xcurriculumIndex = p.xcurriculumIndex;
                  // console.log(student.xprofession);
                });
              }
              if (student.xcurriculum) {
                student.xcurriculum.ref.get().then((doc) => {
                  let c = doc.data();
                  c.id = doc.id;
                  c.ref = doc.ref;
                  student.origRef.update({ xcurriculum: c }).then(() => {
                    student.xcurriculum = c;
                    student.xcurriculumName = c.name;
                    student.curriculumTotalCredit = c.credit ? c.credit : null;
                  });
                });
              }
              this.diplomaStudents.push(student);
            });
        });
      });
  },

  methods: {
    _completeStudies() {
      this.userProfile.school.ref
        .collection("xBeingStates")
        .get()
        .then((states) => {
          states.docs.forEach((doc) => {
            if (doc.data().code == 6) {
              const st = doc.data();
              st.ref = doc.ref;
              st.id = doc.id;
              this.diplomaStudents.forEach((student,index) => {
                // console.log(index, student.ref.path , 'saved');
                student.ref
                  .update({
                    state: st,
                    finishedStudyAt: new Date(),
                    finishedStudyYear: 2023,
                    finishedStudyMonth: 6,
                  })
                  .then(() => {
                    console.log((index+1), student.ref.path , 'saved');
                  });
              });
            }
          });
        });
    },
    _printedAll(student) {
      student.ref
        .update({
          printedAll: !student.printedAll,
          printedAllAt: new Date(),
        })
        .then(() => {
          student.printedAll = !student.printedAll;
          student.printedAllAt = new Date();
          console.log(student.printedAll);
        });
    },
    _confirmGPAScores() {
      this.selectedStudent.ref
        .update({
          studentScoresConfirmed: !this.selectedStudent.studentScoresConfirmed,
        })
        .then(() => {
          this.selectedStudent.studentScoresConfirmed =
            !this.selectedStudent.studentScoresConfirmed;
          this.studentScoresConfirmed =
            this.selectedStudent.studentScoresConfirmed;
        });
    },
    getPt(cm) {
      return cm * 28.3465;
    },
    async _genereatePage(pdfDoc, simpleFont, boldFont, student) {
      var page = pdfDoc.addPage();
      // page.setSize(PageSizes.A4);
      student.currentDate =
        new Date().toLocaleString("default", { month: "long" }) +
        " " +
        new Date().getDate() +
        ", " +
        new Date().getFullYear();

      console.log(student.currentDate);
      page.setWidth(PageSizes.A4[1]);
      page.setHeight(PageSizes.A4[0]);
      const { width, height } = page.getSize();
      for (const text of this.ui_settingPage1EN.texts) {
        if (text.text) {
          if (text.isUpperCase) {
            text.text = text.text.toUpperCase();
            student[text.nextVariableName] =
              student[text.nextVariableName].toUpperCase();
          }
          page.drawText(
            text.nextVariableName
              ? text.text + " " + student[text.nextVariableName]
              : text.text,
            {
              x: text.x,
              y: text.y,
              font: text.isBold ? boldFont : simpleFont,
              size: text.fontSize ? text.fontSize : 12,
              // color: rgb(0.95, 0.1, 0.1),
              // rotate: degrees(-45),
            }
          );
        } else if (text.isVariable) {
          var tmpText = student[text.variableName]
            ? student[text.variableName].toString()
            : "";
          if (text.isUpperCase) tmpText = tmpText.toUpperCase();
          if (student[text.nextVariableName]) {
            tmpText = tmpText + " " + student[text.nextVariableName];
          }
          console.log(student);
          page.drawText(tmpText, {
            x: text.x,
            y: text.y,
            font: text.isBold ? boldFont : simpleFont,
            size: text.fontSize ? text.fontSize : 12,
            // color: rgb(0.95, 0.1, 0.1),
            // rotate: degrees(-45),
          });
          // if (text.nextVariableName) {
          //   student[text.nextVariableName],
          //     {
          //       x: text.x+100,
          //       y: text.y,
          //       font: ubuntuFont,
          //       size: text.fontSize ? text.fontSize : 12,
          //     };
          // }
        }
      }
    },
    // async _genereatePage(pdfDoc, ubuntuFont, student) {
    //   const page = pdfDoc.addPage();

    //   const simpleFont = await pdfDoc.embedFont("Helvetica");
    //   const fontSize = 12;

    //   const boldFont = await pdfDoc.embedFont("Helvetica-Bold");

    //   const x = 50;
    //   const y = 550;

    //   const textParts = [];

    //   for (const xx of [1, 2,  ]) {
    //     textParts.push({ content: "Bold",  isBold: true });
    //     textParts.push({ content: " Text",  isBold: false });
    //   }
    //   let currentX = x;
    //   let currentY = y;

    //   for (const { content, font,isBold } of textParts) {
    //     const options = {
    //       font: isBold?boldFont:simpleFont,
    //       size: fontSize,
    //       color: rgb(0, 0, 0),
    //     };

    //     page.drawText(content, { x: currentX, currentY, ...options });

    //     currentX += 100;
    //     currentY += 100
    //   }

    //   const pdfBytes = await pdfDoc.save();
    // },
    async generatePdf() {
      fb.db
        .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
        .doc("diploma-template-ui-page1-en")
        .onSnapshot(async (doc) => {
          this.ui_settingPage1EN = doc.data();
          this.ui_settingPage1EN.ref = doc.ref;
          this.ui_settingPage1EN.id = doc.id;
          const url = "https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf";
          const fontBytes = await fetch(url).then((res) => res.arrayBuffer());
          const pdfDoc = await PDFDocument.create();
          pdfDoc.registerFontkit(fontkit);
          const simpleFont = await pdfDoc.embedFont(fontBytes);
          const boldFont = await pdfDoc.embedFont("Helvetica-Bold");

          for (const student of this.diplomaStudents) {
            this._genereatePage(pdfDoc, simpleFont, boldFont, student);
          }

          // Generate a Uint8Array representation of the PDF document
          const pdfBytes = await pdfDoc.save();

          // Save the PDF or perform other operations with the generated PDF data
          // For example, you can create a download link to save the PDF locally:
          const blob = new Blob([pdfBytes], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "all-diplomEN.pdf";
          link.click();
        });
    },
    _editStudent(item) {
      console.log(item);
      this.selectedStudent = item;
      this.copiedStudent = Object.assign({}, item);
      this.showEditStudentDialog = true;
    },
    _saveStudent(item) {
      this.copiedStudent.origRef.update(this.copiedStudent).then(() => {
        this.selectedStudent.xcurriculum = this.copiedStudent.xcurriculum;
        this.selectedStudent.xcurriculumName =
          this.copiedStudent.xcurriculum.name;
        this.selectedStudent.xprofession = this.copiedStudent.xprofession;
        this.selectedStudent.firstName = this.copiedStudent.firstName;
        this.selectedStudent.lastName = this.copiedStudent.lastName;
        this.selectedStudent.enteredYear = this.copiedStudent.enteredYear;
        this.selectedStudent.finishedYear = this.copiedStudent.finishedYear;
        this.selectedStudent.currentGPA = this.copiedStudent.currentGPA;
        this.copiedStudent = null;
        this.showEditStudentDialog = false;
      });
    },
    _addScores(item, index) {
      this.editedItem = item;
      console.log(item.ref.path);
      this.$router.push({
        name: "AdminStudentScores",
        params: { studentPath: item.ref.path },
      });
    },
    _goPage2(item) {
      console.log(item.profession.xcurriculum.ref.path);
      const routeData = this.$router.push({
        name: "DiplomaScoreTemplate",
        params: {
          curriculumId:
            "schools/YJHjHWUGDok8teDhDIKX/curriculums/AX9VrLoCNr4SeNvhvqsw",
        },
      });
    },
    _updateProperty(item, propName) {
      this.selectedStudent = item;
      var propp = {};
      propp[propName] = !this.selectedStudent[propName];
      this.selectedStudent.origRef.update(propp).then(() => {
        item[propName] = !item[propName];
      });
    },
    _addDiplomaTopic(item) {
      console.log(item.ref.path);
      this.selectedStudent = item;
      this.showDiplomaConfigDialog = !this.showDiplomaConfigDialog;
    },
    _saveDiplomaCheckList(selectedStudent) {
      console.log(this.selectedStudent, this.selectedStudent.origRef.path);
      var dataa = {};

      dataa._diplomaTitleOK = this.selectedStudent._diplomaTitleOK
        ? this.selectedStudent._diplomaTitleOK
        : false;
      dataa._diplomaCurriculumOK = this.selectedStudent._diplomaCurriculumOK
        ? this.selectedStudent._diplomaCurriculumOK
        : false;
      dataa._diplomaProfessionOk = this.selectedStudent._diplomaProfessionOk
        ? this.selectedStudent._diplomaProfessionOk
        : false;
      dataa._diplomaProfessionIndexOK = this.selectedStudent
        ._diplomaProfessionIndexOK
        ? this.selectedStudent._diplomaProfessionIndexOK
        : false;
      dataa._diplomaStudentScoresOK = this.selectedStudent
        ._diplomaStudentScoresOK
        ? this.selectedStudent._diplomaStudentScoresOK
        : false;
      dataa._diplomaRegisterNumberOK = this.selectedStudent
        ._diplomaRegisterNumberOK
        ? this.selectedStudent._diplomaRegisterNumberOK
        : false;
      console.log(dataa);
      this.selectedStudent.origRef.update(dataa).then(() => {
        this.selectedStudent = null;
        this.checkListDialog = false;
      });
    },
    _saveDiplomaWork() {
      console.log(this.selectedStudent.ref.path);
      this.selectedStudent.ref
        .update({
          diplomWorkTitle: this.selectedStudent.diplomWorkTitle
            ? this.selectedStudent.diplomWorkTitle
            : null,
          diplomWorkTitleEN: this.selectedStudent.diplomWorkTitleEN
            ? this.selectedStudent.diplomWorkTitleEN
            : null,
          diplomWorkTitleMB: this.selectedStudent.diplomWorkTitleMB
            ? this.selectedStudent.diplomWorkTitleMB
            : null,
          diplomaRegisterNumber: this.selectedStudent.diplomaRegisterNumber
            ? this.selectedStudent.diplomaRegisterNumber
            : null,
          diplomaPaperNumber: this.selectedStudent.diplomaPaperNumber
            ? this.selectedStudent.diplomaPaperNumber
            : null,
        })
        .then(() => {
          this.selectedStudent = null;
          this.showDiplomaConfigDialog = false;
        });
    },
    _handleRowClick(item) {
      this.selectedStudent = item;
    },
    _saveCommittee() {
      this.userProfile.ref.parent.parent
        .collection("_schoolDatas")
        .doc("diplomadata")
        .set({ signaturess: ["A", "B"] }, { merge: true })
        .then(() => {
          console.log(this.userProfile.ref.path);
        });
    },

    _removeStudent(item) {
      console.log(item.diplomaListRef.path);
      var yes = confirm(item.firstName + ": жагсаалтаас гаргаx уу?");
      if (yes) {
        item.diplomaListRef.delete();
      }
    },
    _addStudent() {
      if (this.selectedStudent) {
        this.userProfile.ref.parent.parent
          .collection("_diplomaStudents")
          .doc(this.selectedStudent.id)
          .set(this.selectedStudent, { merge: true })
          .then(() => {
            console.log("added", this.userProfile.ref.parent.parent);
          });
      }
    },
    _showDiplomaTemplate(item) {
      this.$router.push({
        name: "DiplomaTemplate",
        params: {
          student: item,
        },
      });
    },
    _printTodorhoilolt(item) {
      fb.db
        .doc(item.origRef.path)
        .get()
        .then((doc) => {
          let student = doc.data();
          student.ref = doc.ref;
          student.id = doc.id;
          console.log();
          this.$router.push({
            name: "TodorhoiloltDetail2",
            params: {
              itemRefPath:
                "schools/YJHjHWUGDok8teDhDIKX/xtodorhoilolt/pSPBHDgvioTxO1efDFnh",
              student: student,
            },
          });
        });
    },
    _searchStudent() {
      if (this.searchWord && this.searchWord.length > 0) {
        fb.db
          .collection(fb.yyschool + "/students")
          .where("studentCode", "==", this.searchWord.toLowerCase())
          .limit(1)
          .get()
          .then((docs) => {
            if (!docs.empty) {
              let student = docs.docs[0].data();
              student.id = docs.docs[0].id;
              student.ref = docs.docs[0].ref;

              if (student && student.studentCode) {
                this.selectedStudent = student;
                this._searchStudentScore1(student.studentCode);
                // this._searchStudentScore2(student.id);
              }
              this.noStudentFound = true;
            }
          });
      }
    },
    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores = [];
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            var datas = await fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
              .where("code", "==", score.lessonCode)
              .limit(1)
              .get();
            if (!datas.empty) {
              var doc = datas.docs[0];
              if (doc != null && doc.exists) {
                score.lesson = doc.data();
              }
            } else {
              // this.accessOK = false
            }
            this.studentScores.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
    // _searchStudentScore2(studentCode) {
    //   fb.db
    //     .collectionGroup("yearScores")
    //     .where("id", "==", studentCode)
    //     .onSnapshot((querySnapshot) => {
    //       var counter = 0;
    //       querySnapshot.forEach(async (doc) => {
    //         let score = doc.data();
    //         score.ref = doc.ref;
    //         score.id = doc.id;
    //         score.index = ++counter;
    //         console.log(score.lessonCode);

    //         if (score.lessonCode) {
    //           var datas = await fb.db
    //             .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
    //             .where("code", "==", score.lessonCode)
    //             .limit(1)
    //             .get();
    //           if (!datas.empty) {
    //             var doc = datas.docs[0];
    //             if (doc != null && doc.exists) {
    //               score.lesson = doc.data();
    //             }
    //           } else {
    //             // this.accessOK = false
    //           }
    //         }

    //         this.studentScores.push(score);
    //       });
    //       if (querySnapshot.empty) {
    //         this.errorMessage = "No Score!";
    //       }
    //     });
    // },
  },
};
</script>
  <style>
</style>
